import React, { useState, useEffect, useRef } from 'react';

const causesData = [
  {
    title: 'ANTI-ADDICTION CAMPAIGN',
    image: '/assets/causes/1.jpg', // Replace with your image path
    alt: 'Anti-Addiction Campaign',
    description: 'Support our initiatives to combat addiction and provide rehabilitation services to those in need.',
  },
  {
    title: 'EDUCATION AND TRAINING',
    image: '/assets/causes/2.jpg', // Replace with your image path
    alt: 'Education and Training',
    description: 'Empower individuals through access to quality education and vocational training programs.',
  },
  {
    title: 'DISASTER WELFARE',
    image: '/assets/causes/3.jpg', // Replace with your image path
    alt: 'Disaster Welfare',
    description: 'Provide immediate relief and long-term support to communities affected by natural disasters.',
  },
  {
    title: 'ENVIRONMENT PROTECTION',
    image: '/assets/causes/4.jpg', // Replace with your image path
    alt: 'ENVIRONMENT PROTECTION',
    description: 'Join our efforts to protect and preserve our planet for future generations through sustainable practices.',
  },
  {
    title: 'INDIVIDUAL CARE',
    image: '/assets/causes/5.jpg', // Replace with your image path
    alt: 'INDIVIDUAL CARE',
    description: 'Offer personalized care and support to vulnerable individuals, ensuring their well-being and dignity.',
  },
  {
    title: 'VALUE AWARENESS',
    image: '/assets/causes/6.jpg', // Replace with your image path
    alt: 'VALUE AWARENESS',
    description: 'Promote ethical values and social responsibility through awareness campaigns and community engagement.',
  },
];

const OurCauses = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const containerRef = useRef(null);
  const [animatedCards, setAnimatedCards] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const triggerPoint = window.innerHeight * 0.75;

      if (containerRect.top < triggerPoint && animatedCards.length === 0) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = Array.from(containerRef.current.children).indexOf(entry.target);
                if (!animatedCards.includes(index)) {
                  setTimeout(() => {
                    setAnimatedCards((prevAnimatedCards) => [...prevAnimatedCards, index]);
                  }, index * 200);
                  observer.unobserve(entry.target);
                }
              }
            });
          },
          { threshold: 0.3 } // Slightly lower threshold
        );

        Array.from(containerRef.current.children).forEach((child) => {
          observer.observe(child);
        });
      }
    }
  }, [scrollPosition, animatedCards]);

  return (
    <section className="our-causes-section">
      <div class="our-causes-header">
        <h2>
          <span class="our-title">OUR</span> &nbsp;
          <span class="causes-title">CAUSES</span>
        </h2>
        <div class="header-underline"></div>
      </div>

      <div className="causes-grid-container" ref={containerRef}>
        {causesData.map((cause, index) => (
          <div
            className={`cause-card-fancy ${animatedCards.includes(index) ? 'slide-in-fancy' : ''}`}
            key={index}
          >
            <div className="cause-card-inner">
              <div className="image-corner">
                <img src={cause.image} alt={cause.alt} className="cause-image-fancy" />
              </div>
              <div className="content-area1">
                <h3 className="cause-title-fancy">{cause.title}</h3>
                <p className="cause-description">{cause.description}</p>
                {/* <button className="learn-more-button">Learn More</button> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurCauses;